<template>
	<div class="white">
		<v-container v-if="missingRecord">
			<v-row justify="center">
				<v-col cols="12" sm="8" md="6" lg="4">
					<v-card>
						<v-card-title primary-title>
							<v-spacer></v-spacer>
							<div>حصل خطا</div>
							<v-spacer></v-spacer>
						</v-card-title>
						<v-card-text>
							<v-row dense>
								<v-col cols="12" class="text-center">الرجاء التواصل مع الإدارة</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<v-container v-else-if="record">
			<v-row justify="center">
				<v-col
					cols="12"
					md="4"
					:style="$vuetify.breakpoint.mdAndUp ? 'position: sticky; top: 36px; height: max-content;' : ''"
				>
					<v-row>
						<v-col cols="12">
							<v-img
								contain
								:src="record.coverPic"
								class="grey lighten-3 mx-auto"
								:aspect-ratio="1/1.4"
								max-width="500"
								@click="showCover = true"
							>
								<template #placeholder>
									<v-row class="fill-height ma-0" align="center" justify="center">
										<v-progress-circular indeterminate color="primary"></v-progress-circular>
									</v-row>
								</template>
							</v-img>
						</v-col>
						
						<v-col cols="auto" class="ma-0 py-0 text-start">
							<span>
								<v-tooltip bottom>
									<template #activator=" {on} ">
										<span v-on="on">
											<v-icon right>mdi-calendar</v-icon>
											{{ record.publishWri }}
										</span>
									</template>
									<span v-if="record.publishDate">{{ record.publishDate.substring(0,10) }}</span>
									<span v-else>غير منشور</span>
								</v-tooltip>
							</span>
						</v-col>
						<v-spacer></v-spacer>
						<v-col cols="auto" class="ma-0 py-0 text-start">
							<v-icon right>mdi-pen</v-icon>
							<router-link :to="{ name: 'dashboard-profile', params: { id: record.userID } }">
								{{ record.userName }}
							</router-link>
						</v-col>
					</v-row>
					<v-divider></v-divider>
					<v-row>
						<v-col cols="12">
							<app-ad v-if="$vuetify.breakpoint.mdAndUp" key="middle" middle></app-ad>
							<app-ad v-else key="sticky" sticky-bottom></app-ad>
						</v-col>
					</v-row>
				</v-col>

				<v-col cols="12" sm="8">
					<v-row>
						<v-col cols="12" class="text-start" style="word-wrap: break-word;">
							<h2 class="text-h6">{{ record.title }}</h2>
							<h3 class="text-body-1">{{ record.description }}</h3>
							<span v-if="configViewCount" class="pe-2">
								<v-icon right>mdi-eye</v-icon>
								{{ record.viewCount }}
							</span>
						</v-col>

						<v-col cols="12">
							<!-- eslint-disable-next-line vue/no-v-html -->
							<p v-html="record.body"></p>
						</v-col>

						<v-col v-if="record.attachments.length" cols="12">
							<b>المرفقات:</b>
							<br />
							<v-data-table
								mobile-breakpoint="0"
								:headers="galleryHeaders"
								:items="record.attachments"
								class="elevation-1"
								hide-default-footer
							>
								<template #[`item.placeName`]="{ item }">
									<a
										:href="item.locationLink"
										target="_blank"
										rel="noopener noreferrer"
									>{{ item.placeName }}</a>
								</template>

								<template #[`item.download`]="{ item }">
									<v-btn text icon color="primary" :href="item.path" target="_blank">
										<v-icon>mdi-file-download</v-icon>
									</v-btn>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-container>

		<app-social-sharing
			v-if="record"
			:id="$route.params.recordID"
			type="news"
			:content="{ url: record.url, title: record.title, description: record.description }"
			:style="$vuetify.breakpoint.mdAndUp ? '' : 'margin-bottom: calc(90/728 * 100vw);'"
		></app-social-sharing>
	</div>
</template>

<script>
import client from "@/client";
import { addBaseURL } from "@/utils/baseURL";
import { textToLink } from "@/utils/textToLink";

export default {
	components: {
		"app-ad": require("@/components/general/AppAd").default,
		"app-social-sharing": require("@/components/general/AppSocialSharing")
			.default
	},
	mixins: [require("@/mixins/router-mixin").default],
	data() {
		return {
			record: null,
			galleryHeaders: [
				{ text: "الاسم", value: "name" },
				{ text: "الوصف", value: "description" },
				{ text: "تحميل", value: "download" }
			],
			missingRecord: false
		};
	},
	computed: {
		configViewCount() {
			return this.$store.state.viewCount;
		}
	},
	mounted() {
		this.getrecord();
	},
	methods: {
		getrecord() {
			client
				.get("/api/news/show/" + this.$route.params.recordID, {})
				.then(response => {
					console.log(response);
					var newData = response.data.data;

					newData.attachments = newData.attachments.map(att => {
						att.path = addBaseURL(att.path);
						if (att.description == "null") {
							att.description = null;
						}

						return att;
					});

					newData.coverPic = addBaseURL(newData.coverPic);

					newData.url = location.href; //for share buttons

					if (newData.body) {
						newData.body = textToLink(newData.body.replace(/&nbsp;/ig, " "));
					}

					this.record = newData;
				})
				.catch(err => {
					this.missingRecord = true;
					console.log(err);
				});
		}
	}
};
</script>